import { FamilyProfile } from '../types/familyProfile';

// Which household framing to use in copy, derived from onboarding's
// adults/kids counts (mirrors the backend's src/emails/household.ts so email
// and in-app copy speak the same way):
//   - "family"    -> has kids (warm, "your family")
//   - "household" -> two or more adults, no kids ("your household")
//   - "solo"      -> a single adult, no kids (second-person "you")
//
// Defaults to "family" when we don't know the household yet (no
// familyProfile) — the warmest option and the brand's core audience.
export type HouseholdSegment = 'family' | 'household' | 'solo';

export const householdSegment = (fp?: Pick<FamilyProfile, 'adults' | 'kids'>): HouseholdSegment => {
  if (!fp) return 'family';
  if (fp.kids > 0) return 'family';
  if (fp.adults > 1) return 'household';
  return 'solo';
};

// Pick the copy variant for the current segment
export const bySegment = (
  segment: HouseholdSegment | undefined,
  variants: Record<HouseholdSegment, string>
): string => variants[segment ?? 'family'];
